import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import React from "react";
function getSiteUrl() {
    var _a;
    if (typeof document !== "undefined") {
        var meta = document.querySelector('meta[name="app:site-url"]');
        if (meta === null || meta === void 0 ? void 0 : meta.content)
            return meta.content;
    }
    if (typeof window !== "undefined" && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.origin)) {
        return window.location.origin;
    }
    return "";
}
export default function Seo(_a) {
    var title = _a.title, _b = _a.description, description = _b === void 0 ? "Vision Cockpit — dashboards, alertas e automações." : _b, canonical = _a.canonical, _c = _a.noindex, noindex = _c === void 0 ? false : _c, ogImage = _a.ogImage, _d = _a.suffix, suffix = _d === void 0 ? "Vision Cockpit" : _d, children = _a.children;
    var _e = useLocation(), pathname = _e.pathname, search = _e.search;
    var base = getSiteUrl();
    var fullTitle = title ? "".concat(title, " | ").concat(suffix) : suffix;
    var canonicalUrl = canonical || (base ? "".concat(base).concat(pathname).concat(search) : "".concat(pathname).concat(search));
    var robots = noindex ? "noindex,nofollow" : "index,follow";
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null, fullTitle),
            React.createElement("meta", { name: "description", content: description }),
            React.createElement("link", { rel: "canonical", href: canonicalUrl }),
            React.createElement("meta", { name: "robots", content: robots }),
            React.createElement("meta", { property: "og:title", content: fullTitle }),
            React.createElement("meta", { property: "og:description", content: description }),
            React.createElement("meta", { property: "og:url", content: canonicalUrl }),
            ogImage && React.createElement("meta", { property: "og:image", content: ogImage }),
            React.createElement("meta", { name: "twitter:card", content: "summary_large_image" })),
        children));
}
